<template>
  <div class="d-flex flex-column account-info">
    <Counters />
    <Socials class="mb-5" />
    <Streams class="mb-5" />
  </div>
</template>

<script>
// import Description from './panels/Description';
import Streams from '@/views/account/sidebarCounters/components/Streams';
// import Streams from './panels/Streams';
import Socials from '@/views/account/sidebarCounters/components/Socials';
import Counters from '@/views/account/sidebarCounters/components/Counters';
// import Platforms from './panels/Platforms';

export default {
  name: 'AccountInfoProfile',
  components: {
    Counters,
    Streams,
    Socials,
  },
};
</script>
